import React from "react";

import { startDate, twoDigit, findCurrentEvent } from "@utils/schedule";
import classnames from "@utils/classnames";
import SEO from "@components/seo";
import styles from "./index.module.scss";

import Box from "@components/box";
import Header from "@components/pages/index/header";
import Video from "@components/pages/index/video";
import Events from "@components/pages/index/events";
// import TestAnimation from '@components/testAnimation'

import huyaImage from "@images/streaming/huya.png";
import douyinImage from "@images/streaming/douyin.png";
import toutiaoImage from "@images/streaming/toutiao.png";
import bilibiliImage from "@images/streaming/bilibili.png";
import kuaishouImage from "@images/streaming/kuaishou.png";
import xiguaImage from "@images/streaming/xigua.png";

const streamingLinks = [
  {
    name: "虎牙直播",
    image: huyaImage,
    href: "https://www.huya.com/gcores"
  },
  {
    name: "抖音直播",
    image: douyinImage,
    href: "https://v.douyin.com/JFHBNoM"
  },
  {
    name: "头条直播",
    image: toutiaoImage,
    href: "https://live.ixigua.com/1352942/"
  },
  {
    name: "西瓜直播",
    image: xiguaImage,
    href: "https://live.ixigua.com/1352942/"
  },
  {
    name: "快手直播",
    image: kuaishouImage,
    href: "https://live.kuaishou.com/u/3x69b24zxxt5a46"
  },
  {
    name: "bilibili直播",
    image: bilibiliImage,
    href: "https://live.bilibili.com/545039"
  }
];

const IndexPage = () => {
  // const currentEvent = findCurrentEvent();
  const currentEvent = true;
  return (
    <>
      <div
        className={classnames(styles.streaming, {
          [styles.activeStreaming]: currentEvent
        })}
      >
        <Box color="aqua" texture="slash" className={styles.box}>
          <div className={styles.itemsWrapper}>
            {streamingLinks.map(item => {
              return (
                <a className={styles.item} href={item.href} key={item.name}>
                  <img src={item.image} alt={item.name} />
                </a>
              );
            })}
          </div>
        </Box>
      </div>
      <SEO />
      <Header />
      <Video />
      <Events />
      {/* <div className={styles.container}>
        <h1>homepage here.</h1>
        <Button to="/about">关于我们</Button>
      </div> */}
    </>
  );
};

export default IndexPage;
